import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { createNewPlanAndFeature, getFeaturesList, getPlan, planList } from "../../../services/PlanService";
import { ControlpanelContext } from "../../../util/context";
import StepProgress from "../../components/StepProgress";
import { steps } from "../../Util";
import "./CreatePlanSubscription.scss";
import CreatePlanSubscription from "./CreatePlanSubscription";
import FeatureSetup from "./FeatureSetup";
import CustomBillingSetup from "./CustomBillingSetup";
import Confirmation from "./Confirmation";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import CommonUtil from "../../../util/CommonUtils";
import SuccessPage from "./SuccessPage";
import Loader from "../../../components/Loader";
import ErrorPage from "../../components/ErrorPage";
import CancelDialog from "../../components/CancelDialog";
export default function CreatePlanContainer() {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [features, setfeatures] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [memberCount, setMemberCount] = useState(0);
    const [highestSequencId, setHighestSequencId] = useState(0);
    const [memberCount1, setMemberCount1] = useState({
        planName: "",
        memberCount: "",
    });
    const [memberCount2, setMemberCount2] = useState({
        planName: "",
        memberCount: "",
    });
    const [payloadFeatures, setPayloadFeatures] = useState({
        DASHBOARD: ["Members Dashboard"],
        TIMESHEET: ["Sundial Time Sheet", "In-App Chatbot Support"],
        REPORT: ["View"],
        INTEGRATION: [],
        OTHERS: ["Multi Language Support"],
        MEMBER_COUNT: ['1']
    });
    const { createPlanPageStepCount, setCreatePlanPageStepCount } = useOutletContext()
    const [isFeatureEnabled, setIsFeatureEnabled] = useState({
        DASHBOARD: true,
        TIMESHEET: true,
        REPORT: true,
        INTEGRATION: false,
        OTHERS: true,
        PROJECT_COUNT: false,
        MEMBER_COUNT: false,
        TAG_COUNT: false,
        DAILY_AI_SUMMARIZATION_LIMITS: false
    });


    const [accountSetup, setAccountSetup] = useState({
        plan_name: "",
        trail_period: 0,
        plan_order: ""
    });

    const [montlyBillingSetup, setMontlyBillingSetup] = useState({
        description: "",
        price: "",
        interval: 1, // interval is nothing but Billing Interval.
        interval_unit: "months" // Interval Unit is nothing but Billing Cycle.
    });
    const [yearlyBillingSetup, setYearlyBillingSetup] = useState({
        description: "",
        price: "",
        interval: 1, // interval is nothing but Billing Interval.
        interval_unit: "years" // Interval Unit is nothing but Billing Cycle.
    });

    const [accountSetupError, setAccountSetupError] = useState({
        plan_name: "",
        trail_period: "",
        plan_order: ""
    });

    const [montlyBillingSetupError, setMontlyBillingSetupError] = useState({
        description: "",
        price: "",
        interval: 1,
        interval_unit: "months"
    });
    const [yearlyBillingSetupError, setYearlyBillingSetupError] = useState({
        description: "",
        price: "",
        interval: 1,
        interval_unit: "years"
    });
    const [payloadFeaturesError, setPayloadFeaturesError] = useState({
        DASHBOARD: [],
        TIMESHEET: [],
        REPORT: [],
        INTEGRATION: [],
        OTHERS: []
    });
    const [isFreeTrial, setIsFreeTrial] = useState(false);
    const [sequenceData, setSequenceData] = useState([]);
    const [errorCancelDialogOpen, setErrorCancelDialogOpen] = useState(false)

    const loadPlans = () => {
        setIsLoading(true);
        const intervalUnit = 'MONTHS';
        var requestData = {
            intervalUnit
        };
        planList(requestData).then((res) => {
            if (res?.status === 200 && res?.data?.code === "RCI0000") {
                let plan = [];
                let plansorted = res.data.data.plans.sort((o1, o2) => o2.planOrder - o1.planOrder);
                plansorted.forEach(extP => {
                    plan.push({
                        id: extP.planOrder,
                        name: extP.name
                    });
                });
                setHighestSequencId(plansorted[0].planOrder)
                setSequenceData(plan);
                setAccountSetup({ ...accountSetup, plan_order: (plan[0]?.id + 1) });
            }
            setIsLoading(false);
        });
    }

    const extractFeatureDetails = (data) => {
        return data?.featureDetails?.map((item) => {
            if (item.feature.code === "MEMBER_COUNT") {
                return item.value;
            }
        });
    };

    const callplans = (order, callback) => {
        getPlan(order)
            .then((res) => {
                if (res?.status === 200 && res?.data?.code === "RCI0000") {
                    callback(res.data.data);
                }
            })
            .catch((error) => {
                console.error("Error in getPlan request:", error);
            });
    }

    useEffect(()=>{
        if(accountSetup.plan_order && accountSetup.plan_order !== 0){
            loadPlanBySequence(highestSequencId)
        }
    },[accountSetup.plan_order])

    const loadPlanBySequence = (seqId) => {
        if (Math.abs(accountSetup.plan_order) == Math.abs(seqId+1)) {
            callplans((seqId), (data) => {
                const mc = extractFeatureDetails(data).filter(f => f !== undefined);
              
                setMemberCount1({
                    planName: data.plansDetails[0].name,
                    memberCount: mc[0]
                });

            });
        } else {
            callplans((Math.abs(accountSetup.plan_order) - 1), (data) => {
                const mc = extractFeatureDetails(data).filter(f => f !== undefined);
                
                setMemberCount1({
                    planName: data.plansDetails[0].name,
                    memberCount: mc[0]
                });

            });
            callplans((Math.abs(accountSetup.plan_order) + 1), (data) => {
                const mc = extractFeatureDetails(data).filter(f => f !== undefined);
                
                setMemberCount2({
                    planName: data.plansDetails[0].name,
                    memberCount: mc[0]
                });

            });
        }

    }

    useEffect(() => {
        getFeaturesList().then((res) => {
            if (res?.status === 200 && res?.data?.code === "RCI0000") {
                setfeatures(res.data.data.features.content);
            } else {
                setfeatures([]);
            }
        });
        loadPlans();
    }, []);

    const validateBillingFields = () => {
        if (CommonUtil.isEmptyString(montlyBillingSetup.price)) {
            setMontlyBillingSetupError({
                ...montlyBillingSetupError,
                price: 'Monthly billing price is required' // t("RAL0800"),
            })
            return false;
        }
        if (Math.abs(montlyBillingSetup.price) < (Math.abs(yearlyBillingSetup.price) / 12)) {
            setMontlyBillingSetupError({
                ...montlyBillingSetupError,
                price: `Value must be greater than yearly price $(${(yearlyBillingSetup.price / 12).toFixed(2)})`
            });
            return false;
        }

        if (CommonUtil.isEmptyString(montlyBillingSetup.description)) {
            setMontlyBillingSetupError({
                ...montlyBillingSetupError,
                description: "Monthly plan description is required"// t("RAL0803"),
            });
            return false;
        }
        if (montlyBillingSetup.description?.length > 255) {
            setMontlyBillingSetupError({
                ...montlyBillingSetupError,
                description: "Monthly plan description cannot exceed 255 characters."// t("RAL0801"),
            });
            return false;
        }
        if (CommonUtil.isEmptyString(yearlyBillingSetup.price)) {
            setYearlyBillingSetupError({
                ...yearlyBillingSetupError,
                price: "Yearly billing price is required" // t("RAL0805"),
            });
            return false;
        }
        if (Math.abs(montlyBillingSetup.price) >= Math.abs(yearlyBillingSetup.price)) {
            setYearlyBillingSetupError({
                ...yearlyBillingSetupError,
                price: `Value must be greater than monthly price`
            });
            return false;
        }
        if (CommonUtil.isEmptyString(yearlyBillingSetup.description)) {
            setYearlyBillingSetupError({
                ...yearlyBillingSetupError,
                description: "Yearly plan description is required"// t("RAL0804"),
            });
            return false;
        }
        if (yearlyBillingSetup.description?.length > 255) {
            setYearlyBillingSetupError({
                ...yearlyBillingSetupError,
                description: "Yearly plan description cannot exceed 255 characters." // t("RAL0802"),
            });
            return false;
        }

        return true;
    }
    const validateAccountFields = () => {
        if (CommonUtil.isEmptyString(accountSetup.plan_name)) {
            setAccountSetupError({
                ...accountSetupError,
                plan_name: "Plan name is required" //t("RAL0797")
            })
            return false;
        }
        if (!CommonUtil.isEmptyString(accountSetup.plan_name)
            && accountSetup.plan_name?.length > 100
        ) {
            setAccountSetupError({
                ...accountSetupError,
                plan_name: "Plan name must be less than 100" //t("RAL0808")
            })
            return false;
        }
        const alreadyNameExit = sequenceData?.map(seq => (seq.name)?.toLowerCase());
        if (!CommonUtil.isEmptyString(accountSetup.plan_name) && alreadyNameExit.includes((accountSetup.plan_name)?.toLowerCase())) {
            setAccountSetupError({
                ...accountSetupError,
                plan_name: "Plan name is already exist." //t("RAL0813")
            })
            return false;
        }
        if (isFreeTrial && CommonUtil.isEmptyString(accountSetup.trail_period)) {
            setAccountSetupError({
                ...accountSetupError,
                trail_period: "Trial period must be between 0 to 60." //t("RAL0798")
            })
            return false;
        }
        if (isFreeTrial && accountSetup.trail_period > 60) {
            setAccountSetupError({
                ...accountSetupError,
                trail_period: "Trial period must be between 0 to 60." //t("RAL0798")
            })
            return false;
        }
        if (CommonUtil.isEmptyString(accountSetup.plan_order)) {
            setAccountSetupError({
                ...accountSetupError,
                plan_order: "Sequence ID is required" //t("RAL0799")
            })
            return false;
        }
        if (accountSetup.plan_order == 0) {
            setAccountSetupError({
                ...accountSetupError,
                plan_order: "Invalid sequence ID. Please enter a valid sequence ID." //t("RAL0824")
            });
            return false;
        }
        if (accountSetup.plan_order > (sequenceData[0]?.id + 1)) {
            setAccountSetupError({
                ...accountSetupError,
                plan_order: "Sequence Id cannot be greater than " + (sequenceData[0]?.id + 1)// t("RAL0812") + " " + (sequenceData[0]?.id + 1)
            })
            return false;
        }
        return true;
    }

    const validateFeaturesFields = () => {

        if (payloadFeatures?.PROJECT_COUNT != undefined && payloadFeatures?.PROJECT_COUNT?.length > 0) {
            if (payloadFeatures.PROJECT_COUNT <= 0 ||
                payloadFeatures.PROJECT_COUNT > 10000
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    PROJECT_COUNT: "Project count must be between 1 to 10000"//t("RAL0809")
                });
                return false;
            }
        }
        
        if (payloadFeatures?.MEMBER_COUNT == undefined || payloadFeatures?.MEMBER_COUNT?.length == 0) {
            setPayloadFeaturesError({
                ...payloadFeaturesError,
                MEMBER_COUNT: "Member count is required" // t("RAL0806")
            });
            return false;
        }
        if (payloadFeatures?.MEMBER_COUNT != undefined && payloadFeatures?.MEMBER_COUNT?.length > 0) {
            if (payloadFeatures.MEMBER_COUNT <= 0 ||
                payloadFeatures.MEMBER_COUNT > 10000
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    MEMBER_COUNT: "Member count must be between 1 to 10000" //t("RAL0807")
                });
                return false;
            }
        }

        if (Math.abs(accountSetup.plan_order) == Math.abs(highestSequencId+1)) {
            if (Math.abs(payloadFeatures.MEMBER_COUNT[0]) < Math.abs(memberCount1.memberCount)) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    MEMBER_COUNT: `${memberCount1.planName} has ${memberCount1.memberCount} members, please select a greater value.`
                });
                return false;
            }
        } else {
            if (Math.abs(payloadFeatures.MEMBER_COUNT[0]) < Math.abs(memberCount1.memberCount)
                || Math.abs(payloadFeatures.MEMBER_COUNT[0]) > Math.abs(memberCount2.memberCount)
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    MEMBER_COUNT: `The member count must be between ${memberCount1.memberCount} and ${memberCount2.memberCount}`
                });
                return false;
            }
        }

        if (payloadFeatures?.TAG_COUNT != undefined && payloadFeatures?.TAG_COUNT?.length > 0) {
            if (payloadFeatures.TAG_COUNT <= 0 ||
                payloadFeatures.TAG_COUNT > 10000
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    TAG_COUNT: "Tag count must be between 1 to 10000" // t("RAL0810")
                });
                return false;
            }
        }
        if (payloadFeatures?.DAILY_AI_SUMMARIZATION_LIMITS != undefined &&
            payloadFeatures?.DAILY_AI_SUMMARIZATION_LIMITS?.length > 0) {
            if (payloadFeatures.DAILY_AI_SUMMARIZATION_LIMITS <= 0 ||
                payloadFeatures.DAILY_AI_SUMMARIZATION_LIMITS > 10000
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    DAILY_AI_SUMMARIZATION_LIMITS: "Daily AI summarization limits count must be between 1 to 10000" //t("RAL0811")
                });
                return false;
            }
        }
        return true;
    }

    const handleNextbutton = () => {

        if (createPlanPageStepCount == 0 && !validateAccountFields()) {
            return;
        }
        if (createPlanPageStepCount == 1 && !validateBillingFields()) {
            return;
        }

        if (createPlanPageStepCount == 2 && !validateFeaturesFields()) {
            return;
        }

        if (createPlanPageStepCount != 3) {
            setCreatePlanPageStepCount(prev => prev + 1)
        }
        else return;
    }

    const handlePrevbutton = () => {
        if (createPlanPageStepCount != 0) {
            setAccountSetupError({
                plan_name: "",
                trail_period: "",
                plan_order: ""
            });

            setMontlyBillingSetupError({
                description: "",
                price: "",
                interval: 1,
                interval_unit: "months"
            });
            setYearlyBillingSetupError({
                description: "",
                price: "",
                interval: 1,
                interval_unit: "years"
            });
            setPayloadFeaturesError({
                DASHBOARD: [],
                TIMESHEET: [],
                REPORT: [],
                INTEGRATION: [],
                OTHERS: []
            });
            setCreatePlanPageStepCount(prev => prev - 1)
        }
        else return;
    }
    const filterValue = (value) => {
        if (value?.includes("All"))
            return "All";
        else return value.join(",")
    }

    const handleConfirm = () => {
        const features1 = []
        Object.entries(payloadFeatures)?.map(pFeature => {
            features.forEach(ftr => {
                if (ftr.code == pFeature[0] && pFeature[1]?.length !== 0) {
                    features1.push({
                        feature_Id: ftr.id,
                        value: filterValue(pFeature[1])
                    })
                }
            })
        })
        const payload = {
            ...accountSetup,
            plans: [
                montlyBillingSetup,
                yearlyBillingSetup
            ],
            features: features1
        }
        setIsLoading(true);
        createNewPlanAndFeature(payload).then((res) => {
            if (res?.status === 200 && res?.data?.code === "RCI0044") {
                setCreatePlanPageStepCount(4);
            }
            else if (res?.data?.code === "RCE0235") {
                setCreatePlanPageStepCount(5);
            }
            else {
                toast.error(res?.data?.message)
            }
            setIsLoading(false)
        });
    }

    const handleCancelError = () => {
        setErrorCancelDialogOpen(true)
    }

    return (
        <ControlpanelContext.Provider
            value={{
                accountSetup, setAccountSetup,
                montlyBillingSetup, setMontlyBillingSetup,
                yearlyBillingSetup, setYearlyBillingSetup,
                features, setfeatures,
                payloadFeatures, setPayloadFeatures,
                createPlanPageStepCount, setCreatePlanPageStepCount,
                isFeatureEnabled, setIsFeatureEnabled,
                isFreeTrial, setIsFreeTrial,
                accountSetupError, montlyBillingSetupError,
                yearlyBillingSetupError,
                setAccountSetupError, setMontlyBillingSetupError,
                setYearlyBillingSetupError,
                payloadFeaturesError, setPayloadFeaturesError,
                sequenceData, setSequenceData
            }}
        >
            <Box height={"100%"} className="create-subscription">
                <StepProgress steps={steps} currentStep={createPlanPageStepCount} />
                <div className="create-subscription-container">
                    <div className="create-subscription-subcontainer">
                        <div>
                            {createPlanPageStepCount == 0 && <CreatePlanSubscription />}
                            {createPlanPageStepCount == 1 && <CustomBillingSetup />}
                            {createPlanPageStepCount == 2 && <FeatureSetup />}
                            {createPlanPageStepCount == 3 && <Confirmation />}
                            {createPlanPageStepCount == 4 && <SuccessPage plan_name={accountSetup.plan_name} />}
                            {createPlanPageStepCount == 5 && <ErrorPage message="OOPS! There was an error while creating the Plan" />}
                            {isLoading && <Loader open={isLoading} />}
                        </div>
                        <div className="create-subscription-button" >
                            {createPlanPageStepCount < 3 && <>
                                <button className={createPlanPageStepCount != 0 ? "prev-button" : "prev-button disbled-button"} onClick={handlePrevbutton}
                                >Previous step</button>
                                <button className="next-button" onClick={handleNextbutton}>Next step</button>
                            </>}
                            {createPlanPageStepCount == 3 && <>
                                <button className={createPlanPageStepCount != 0 ? "prev-button" : "prev-button disbled-button"} onClick={handlePrevbutton}
                                >Move back</button>
                                <button className="next-button" onClick={handleConfirm}>Confirm</button>
                            </>}
                            {createPlanPageStepCount == 4 && <>
                                <button className="back-to-list-button" onClick={() => { setCreatePlanPageStepCount(0); navigate("/plans") }}
                                >Back to subscription list</button>
                            </>}
                            {createPlanPageStepCount == 5 && <>
                                <button className={"prev-button"} onClick={handleCancelError}
                                >Cancel</button>
                                <button className="next-button" onClick={() => setCreatePlanPageStepCount(3)}>Try again</button>
                            </>}
                        </div>
                    </div>
                </div>
            </Box>
            {errorCancelDialogOpen && <CancelDialog
                open={errorCancelDialogOpen}
                onClose={() => { setCreatePlanPageStepCount(0); setErrorCancelDialogOpen(false) }}
                onConfirm={() => { setCreatePlanPageStepCount(0); setErrorCancelDialogOpen(false); navigate("/plans") }}
                title={"Cancellation Confirmation"}
                content={"Are you sure you want to cancel creating this plan? All unsaved changes will be lost."}
            />}
        </ControlpanelContext.Provider>
    );
}
